import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import Badge from 'js/components/shared/Badge'
import SectionLoader from '../SectionLoader';

import styles from './RestaurantSection.module.scss'

const cx = classnames.bind(styles);

const RestaurantSection = function ({
  isLoading = false,
  info = {},
  className = '',
}) {
  const renderData = useMemo(function () {
    return Object.values(info)
      .sort((a, b) => a.sort > b.sort ? -1 : 1)
      .reduce(function (reducer, item) {
        if (item?.list?.length) {
          const items = item.list.map(el => (typeof el === 'string' ? {text: el} : el))
          reducer = reducer.concat(items)
        }
        if (item?.nested?.list?.length) {
          reducer.push({
            text: item.nested.label,
            link: item.nested.link,
            children: item.nested.list,
          })
        }
        return reducer;
      }, [])
  }, [info])

  return (
    <div className={cx('root', className)}>
      {isLoading && (<SectionLoader className={cx('root', 'loader-root')} />)}
      {!isLoading && (
        <ul>
          {renderData.map((el, i) => (
            <li key={'list:' + i}>
              {!el.link && (<span>{el.text}</span>)}
              {el.link && (
                <a
                  className={cx(el.link.class, 'item-link')}
                  href={'#' + el.link['amenity-code']}
                  data-hotel-id={el.link['hotel-id']}
                  data-amenity-code={el.link['amenity-code']}
                >
                  {el.text}
                </a>
              )}
              {!!el?.children?.length && (
                <ul>
                  {el.children.map((child, k) => (
                    <li key={'sublist:' + k}>
                      {child.text}
                      {!!child.paying.length && (
                        <Badge className={cx('paying')} color="gray" theme="semi-round">{child.paying}</Badge>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

RestaurantSection.propTypes = {
  isLoading: PropTypes.bool,
  info: PropTypes.object,
}

export default RestaurantSection;
